import React from 'react'

const EnjoyLiftMessageWrapper = () => {
    return (
        <div className='font-semibold text-xl sm:text-4xl text-center tracking-widest leading-8 sm:leading-10 text-main-800 py-10 sm:py-20'>
            <p className='mb-2'>良質な睡眠から始める、より良い1日</p>
            <p>睡眠への投資はあなたの未来への投資</p>
        </div>
    )
}

export default EnjoyLiftMessageWrapper